export default __webpack_public_path__ + "static/media/mascot.b9cd8473.png";